import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import {
  MdNotificationsNone,
  MdOutlinePerson,
  MdGridView,
  MdManageAccounts,
  MdPeople,
  MdSearch,
  MdRecommend,
  MdHome,
  MdScience,
  MdOutlineScience,
  MdOutlineHome,
  MdOutlineSearch,
  MdOutlineRecommend,
  MdOutlinePeople,
  MdOutlineThumbUpOffAlt,
  MdOutlineSchool,
} from 'react-icons/md'
import { useNavigate } from 'react-router'
import {
  persistor,
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../store'
import { UserAll, UserRole } from '../../models/User'
import Popup from '../Popup/Popup'
import LoginForm from '../Popup/LoginForm'
import { Button, IconButton, Menu as MMenu } from '@mui/material'

import {
  asyncLogin,
  LoginFormValues,
  SignUpFormValues,
  resetApiResult,
  setMenuIndex,
  asyncSignup,
  UserState,
  setSelectGroupId,
} from '../../store/userSlice'
import SignUpForm from '../Popup/SignUpForm'
import { Toaster } from 'react-hot-toast'
import { asyncGetFriends, asyncGetJobCategories } from '../../store/mainSlice'
import { FriendToUser } from '../../models/FriendToUser'
import { Logout } from '@mui/icons-material'
import { UserGroup } from '../../models/UserGroup'
import { axiosGet } from '../Common/Axios'
import { ApiResult } from '../../models/Enums'

function Header() {
  const navigate = useNavigate()

  const [openLogin, setOpenLogin] = useState(false)
  const [openSignUp, setOpenSignUp] = useState(false)

  const userState = useSelector((state: RootState) => state.user)
  const dispatch = useAppDispatch()

  // _delete
  const friends = useSelector((state: RootState) => state.main.friends)
  const [groups, setGroups] = useState<UserGroup[]>([])

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [open, setOpen] = React.useState(false)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }
  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }

  const handleMyPage = () => {
    setAnchorEl(null)
    setOpen(false)
    navigate('/mypage')
  }

  // _delete
  useEffect(() => {
    async function getFriend() {
      dispatch(asyncGetFriends(userState.me.id))
      // if (friends.length === 0) {
      //   dispatch(asyncGetFriends(userState.me.id))
      // }
    }

    async function getMentorGroup(userId: number) {
      if (
        userState.me !== undefined &&
        userState.me.userRole === UserRole.MENTOR
      ) {
        const result = await axiosGet(`/api/user/group/${userId}`)
        if (result.apiResult != ApiResult.SUCCESS) {
          console.log('get_group error', result.apiResult, result.message)
          return
        }
        const mentorGroup = result.data
        const groupId = mentorGroup.length > 0 ? mentorGroup[0].id : 0

        setGroups(mentorGroup)

        dispatch(setSelectGroupId(groupId))
      }
    }

    getMentorGroup(userState.me.id)
  }, [userState.me.id])

  // _delete
  const onChangeFriend = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    //await onLogout()
    await persistor.purge()
    navigate('/')

    const userid = e.target.value

    const result = await axiosGet(`/api/user/get_student/${userid}`)
    if (result.apiResult != ApiResult.SUCCESS) {
      console.log('get_student error', result.apiResult, result.message)
      return
    }

    const userInfo = result.data as UserAll
    const password = userInfo.plainPassword
    const user = await dispatch(asyncLogin({ userid, password }))

    dispatch(asyncGetFriends((user.payload as UserState).me.id))
  }

  const onChangeGroup = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setSelectGroupId(parseInt(e.target.value)))
  }

  // 회원가입
  const onSignUp = async (values: SignUpFormValues) => {
    dispatch(resetApiResult())
    dispatch(asyncSignup(values))
  }

  // 로그인
  const onLogin = async (values: LoginFormValues) => {
    dispatch(resetApiResult())
    const us = await dispatch(asyncLogin(values))

    const uss: UserState = us.payload as UserState
    const url =
      uss.me.userRole == UserRole.MENTEE
        ? '/mentee'
        : uss.me.userRole == UserRole.MENTOR
        ? '/mentor'
        : '/admin/jobclass'

    navigate(url)

    // 로그인시 JobCategories를 가져온다
    await dispatch(asyncGetJobCategories())
  }

  // 로그아웃
  const onLogout = async () => {
    await persistor.purge()
    navigate('/')
    setOpenLogin(false)
    setOpen(false)

    //dispatch(clearJobCategories())
  }

  const navigateUrl = (index: number, url: string) => {
    dispatch(setMenuIndex(index))
    navigate(url)
  }

  return (
    <>
      <ToasterParent>
        <Toaster position="top-center" />
      </ToasterParent>
      <Container>
        <Content>
          <Logo className="logo" onClick={() => navigate('/')}>
            <img src="/images/home-logo.svg" alt="" />
            <span>pathfinder</span>
          </Logo>

          {(userState.me === undefined ||
            userState.me.userRole === UserRole.GUEST) && (
            <SignBar>
              <Popup
                open={openLogin}
                setOpen={setOpenLogin}
                isTopCenter={false}
              >
                <LoginForm onLogin={onLogin} />
              </Popup>
              <button onClick={() => setOpenLogin(true)}>로그인</button>

              <Popup
                open={openSignUp}
                setOpen={setOpenSignUp}
                isTopCenter={false}
              >
                <SignUpForm onSignUp={onSignUp} />
              </Popup>
              <button onClick={() => setOpenSignUp(true)}>회원가입</button>
            </SignBar>
          )}

          {userState.me && userState.me.userRole === UserRole.MENTEE && (
            <>
              <Menu>
                <MenuItem
                  onClick={() => navigateUrl(0, '/mentee')}
                  value={userState.menuIndex === 0 ? 'selected' : ''}
                >
                  <MdOutlineHome className="icon" /> <span>홈</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(1, '/mentee/test')}
                  value={userState.menuIndex === 1 ? 'selected' : ''}
                >
                  <MdOutlineScience className="icon" /> <span>직업테스트</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(2, '/mentee/search')}
                  value={userState.menuIndex === 2 ? 'selected' : ''}
                >
                  <MdOutlineSearch className="icon" /> <span>직업검색</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(3, '/mentee/recommend')}
                  value={userState.menuIndex === 3 ? 'selected' : ''}
                >
                  <MdOutlineThumbUpOffAlt className="icon" /> <span>추천</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(4, '/mentee/friend')}
                  value={userState.menuIndex === 4 ? 'selected' : ''}
                >
                  <MdOutlinePeople className="icon" /> <span>친구</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(5, '/mentee/inventory')}
                  value={userState.menuIndex === 5 ? 'selected' : ''}
                >
                  <MdGridView className="icon" /> <span>인벤토리</span>
                </MenuItem>

                <MenuItem
                  onClick={() => navigateUrl(6, '/mentee/jobclass')}
                  value={userState.menuIndex === 6 ? 'selected' : ''}
                >
                  <MdOutlineSchool className="icon" /> <span>수업</span>
                </MenuItem>
              </Menu>
              <IconMenu>
                <div style={{ paddingTop: '10px' }}>
                  {userState.me.username}
                </div>
                {process.env.REACT_APP_IS_SHOW_TEST_FRIEND_LIST === 'true' && (
                  <select
                    style={{ margin: '0 10px' }}
                    onChange={onChangeFriend}
                    value={userState.me.id}
                  >
                    <option key={userState.me.id} value={userState.me.userid}>
                      나
                    </option>
                    {friends &&
                      friends.map((friend) => (
                        <option
                          key={friend.friend.id}
                          value={friend.friend.userid}
                        >
                          {friend.friend.username}
                        </option>
                      ))}
                  </select>
                )}
                {/* <IconButton>
                  <MdNotificationsNone className="iconNotification" />
                </IconButton> */}
                <IconButton
                  id="user-menu-button"
                  aria-controls={open ? 'user-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <MdOutlinePerson />
                </IconButton>
                <MMenu
                  id="user-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'user-menu-button',
                  }}
                >
                  <PopupMenuItem onClick={handleMyPage}>
                    마이페이지
                  </PopupMenuItem>
                  <PopupMenuItem onClick={() => onLogout()}>
                    로그아웃
                  </PopupMenuItem>
                </MMenu>
              </IconMenu>
            </>
          )}
          {userState.me && userState.me.userRole === UserRole.MENTOR && (
            <>
              <Menu>
                <MenuItem
                  onClick={() => navigateUrl(0, '/mentor')}
                  value={userState.menuIndex === 0 ? 'selected' : ''}
                >
                  <MdManageAccounts className="icon" /> <span>홈</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(1, '/mentor/mentee')}
                  value={userState.menuIndex === 1 ? 'selected' : ''}
                >
                  <MdManageAccounts className="icon" />
                  <span>학생관리</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(2, '/mentor/search')}
                  value={userState.menuIndex === 2 ? 'selected' : ''}
                >
                  <MdSearch className="icon" /> <span>직업검색</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(3, '/mentor/jobclass')}
                  value={userState.menuIndex === 3 ? 'selected' : ''}
                >
                  <MdGridView className="icon" /> <span>수업</span>
                </MenuItem>
              </Menu>
              <IconMenu>
                <div>
                  <select onChange={onChangeGroup}>
                    {groups.map((group) => (
                      <option key={group.id} value={group.id}>
                        {group.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>{userState.me.username}</div>
                <IconButton
                  id="user-menu-button"
                  aria-controls={open ? 'user-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <MdOutlinePerson />
                </IconButton>
                <MMenu
                  id="user-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'user-menu-button',
                  }}
                >
                  <PopupMenuItem onClick={handleClose}>정보보기</PopupMenuItem>
                  <PopupMenuItem onClick={() => onLogout()}>
                    로그아웃
                  </PopupMenuItem>
                </MMenu>
              </IconMenu>
            </>
          )}
          {userState.me && userState.me.userRole === UserRole.ADMIN && (
            <>
              <Menu>
                <MenuItem
                  onClick={() => navigateUrl(0, '/admin/jobclass')}
                  value={userState.menuIndex === 0 ? 'selected' : ''}
                >
                  <MdSearch className="icon" /> <span>수업관리</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(1, '/admin/instructor')}
                  value={userState.menuIndex === 1 ? 'selected' : ''}
                >
                  <MdManageAccounts className="icon" /> <span>강사관리</span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigateUrl(2, '/admin/jobs')}
                  value={userState.menuIndex === 2 ? 'selected' : ''}
                >
                  <MdManageAccounts className="icon" />{' '}
                  <span>전체 직업보기</span>
                </MenuItem>
                <MenuItem onClick={() => onLogout()}>로그아웃</MenuItem>
              </Menu>
            </>
          )}
        </Content>
      </Container>
    </>
  )
}

const Container = styled.div`
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  margin: 0 auto;
  z-index: 100;
  background-color: white;
  box-shadow: 0 1px 0 0 rgb(0 0 0 / 10%);
`
const Content = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  max-width: 1100px;
  min-height: 100%;
  //padding: 2px 6%;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: row;
    padding: 0;
    width: 100%;
  }
`
const ToasterParent = styled.div`
  z-index: 150;
`

const Logo = styled.div`
  margin-right: 6rem;
  padding: 6px 0;
  display: flex;
  align-items: center;

  img {
    background-color: var(--point-color1);
    border-radius: 6px;
    padding: 4px;
    width: 19px;
    margin-top: 4px;
    margin-right: 0;
  }
  span {
    font-size: 1.5rem;
    padding-left: 10px;
    font-weight: 700;
    text-decoration: none;
    color: #333333;

    @media (max-width: 768px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    padding-left: 35px;
    margin-right: 0;
  }
`

const Menu = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  column-gap: 25px;
  list-style: none;
  color: rgb(51, 51, 51);

  @media (max-width: 768px) {
    position: fixed;
    left: 0;
    bottom: 0;
    background: white;
    width: 100vw;
    box-sizing: border-box;
    justify-content: space-around;
    column-gap: 0px;
  }
`
const MenuItem = styled.li`
  padding: 13px 0px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0px;
  row-gap: 3px;

  @media (max-width: 768px) {
    text-align: center;
  }

  &:hover {
    -webkit-box-shadow: inset 0 -2px #258bf7;
    box-shadow: inset 0 -2px #258bf7;
  }

  border-bottom: ${(props) =>
    props.value && props.value === 'selected' ? '3px solid #258bf7' : 'none'};

  .icon {
    font-size: 1.4rem;
    display: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 14px 10px;

    .icon {
      font-size: 1.6rem;
      display: block;
    }
  }
`

const PopupMenuItem = styled(MenuItem)`
  padding: 13px 20px;
`

const IconMenu = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
  color: #888;
  margin-right: 15px;

  img {
    width: 30px;
    padding: 0 10px;
    &:hover {
      border-bottom: 1px solid rgba(0, 0, 0, 0.8);
    }
  }

  .iconNotification {
  }
  .iconPerson {
    font-size: 1rem;
    font-weight: 700;
    padding: 3px;
    border: 2px solid #666;
    border-radius: 50%;
  }

  select {
    padding: 5px 10px;
  }

  @media (max-width: 768px) {
    margin-right: 35px;
  }
`
const SignBar = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1px;
  justify-content: right;
  font-size: 1.6rem;
  color: #888;
  margin-right: 15px;

  button {
    cursor: pointer;
    border: none;
    background-color: transparent;
    padding: 10px 20px;
    &:hover {
      color: #00f;
      background-color: aliceblue;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export default Header
